import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-qatar-market-study',
  templateUrl: './qatar-market-study.component.html',
  styleUrls: ['./qatar-market-study.component.css']
})
export class QatarMarketStudyComponent implements OnInit {

  output:any =[];
  isLoader = false;
  body = true
  space=" "

  constructor(private service: ServiceService, private route: ActivatedRoute, private router: Router) {
   
  }

//excel Export For CustomerKyc
  excelExport() {
    var orderTable = document.getElementById('MarketStudy');
    var wb = XLSX.utils.table_to_book(orderTable, { sheet: "sheet1" });

    return XLSX.writeFile(wb, ('Qatar Market Study Report.' + ('xlsx')));


  }

  ngOnInit(): void {

    this.service.viewQatarMarketStudy().subscribe((res)=>{
          this.output=res.data
          console.log("data=",this.output)
          console.log("res=",res)         
          })  
    }

}
